import { useTranslation } from "react-i18next";
import "./exchange-modal.scss";
import { useAppSelector } from "../../../../hook";
import { RootState } from "../../../../store";
import { createFormattedDateString, numberWithSpaces } from "../../../../helper/date.helper";

interface ExchangeModalProps {
    open: boolean;
    title: string;
    id: number;
    date: string;
    exchangeRate: string;
    netPrice: string;
    onCloseButtonClick: () => void;
}

export const ExchangeModal = (props: ExchangeModalProps) => {
    const { t } = useTranslation();

    const exchangeRates = useAppSelector((state: RootState) => state.exchangeRate.exchangeRates);

    const date = exchangeRates?.find((x) => x.fundId === props.id)?.date;
    const rate = exchangeRates?.find((x) => x.fundId === props.id)?.exchangeRate;
    const price = exchangeRates?.find((x) => x.fundId === props.id)?.netPrice;

    return (
        <div className={`exchange-modal ${props.open ? `` : `hidden`}`}>
            <div className="exchange-modal-top-bar">
                <h1 className="exchange-modal-title">{props.title}</h1>

                <button className="close-button" onClick={() => props.onCloseButtonClick()}>
                    <img alt="Bezárás ikon" src="/image/ic_close_modal.svg" />
                </button>
            </div>

            <div className="exchange-modal-bottom">
                <div className="exchange-modal-container">
                    <p className="exchange-modal-sub-title">{t("header_founds_date_title")}</p>
                    <p className="exchange-modal-sub-title">
                        {date !== null && date !== undefined ? createFormattedDateString(date!) : ""}
                    </p>
                </div>

                <div className="exchange-modal-container" style={{ backgroundColor: "white" }}>
                    <p className="exchange-modal-sub-title">{t("header_founds_exchange_rate_title")}</p>
                    <p className="exchange-modal-sub-title">{exchangeRates !== null ? rate : ""} EUR</p>
                </div>

                <div className="exchange-modal-container">
                    <p className="exchange-modal-sub-title">{t("header_founds_net_price_title")}</p>
                    <p className="exchange-modal-sub-title">{price !== null && price !== undefined ? numberWithSpaces(price) : ""} EUR</p>
                </div>
            </div>
        </div>
    );
};
